//initial values
const LoginInitialValues = {
  email: "",
  password: "",
};

const agronomistInitialValues = {
  email: "",
  firstName: "",
  lastName: "",
  countryCode: "",
  phoneNumber: "",
  location: "",
  agronomistFile: "",
};
const cropInitialValues = {
  name: "",
};
const profileInitialValues = {
  profileImage: "",
  fullName: "",
  emailAddress: "",
};
const changePasswordInitialValues = {
  oldPassword: "",
  password: "",
  confirmPassword: "",
};

const productInitialValues = {
  productName: "",
  rate: "",
  rateUnit: "",
  containerSize: "",
  containerUnit: "",
  containerType: "",
  note: "",
};
const growerInitialValues = {
  email: "",
  firstName: "",
  lastName: "",
  countryCode: "",
  phoneNumber: "",
  location: "",
  growerFile: "",
};
const yearInitialValues = {
  seasonId: "",
  year: "",
};
const scoutingInitialValues = {
  scoutTimeType: "scoutTimeTaken",
  scoutTime: "",
  scoutTimeManual: "",
  cropStage: "",
  cropStageFiles: [],
  removeCropStageFiles: [],
  observation: [
    {
      observation: "",
      observationFiles: [],
      removeObservationFiles: [],
    },
  ],
  recommendation: [
    {
      recommendation: "",
      recommendationFiles: [],
      removeRecommendationFiles: [],
    },
  ],
  mixSheetFile: "",
  removeMixSheetFile: [],
};
const addCropPlanInitialValues = {
  growingSeason: "",
  description: "",
  planStatus: "Template",
};

export {
  LoginInitialValues,
  agronomistInitialValues,
  profileInitialValues,
  changePasswordInitialValues,
  productInitialValues,
  growerInitialValues,
  cropInitialValues,
  yearInitialValues,
  scoutingInitialValues,
  addCropPlanInitialValues,
};
